"use client";
import * as React from 'react';
import { cn } from '../../utils/ui';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('bg-muted rounded-md animate-pulse', className)} {...props} />;
}

export { Skeleton };
